export const state = {
    loading: false,
    title: '',
    alerts: [],
    sidebarSize: 'lg',
    listRefreshKey: 1,
};
export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    alerts: function (state) {
        return JSON.parse(JSON.stringify(state.alerts));
    },
    title: function (state) {
        return state.title;
    },
    listRefreshKey: function (state) {
        return Number(state.listRefreshKey);
    },
    sidebarSize: function (state) {
        return state.sidebarSize;
    }
};
export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_ALERTS': function (state, items) {
        state.alerts = items;
    },
    'ADD_ALERT': function (state, alert) {
        if (!state.alerts) {
            state.alerts = [];
        }
        state.alerts.push(alert);
    },
    'REMOVE_ALERT' (state, index) {
        state.alerts.splice(index, 1);
    },
    'SET_TITLE': function (state, title) {
        state.title = title;
    },
    'INCREASE_LIST_REFRESH_KEY': function (state) {
        state.listRefreshKey += 1;
    },
    'SET_SIDEBAR_SIZE': function (state, size) {
        state.sidebarSize = size;
    },
};

export const actions = {
    title: function ({commit}, title) {
        commit('SET_TITLE', title)
    },

    addAlert: function ({commit}, payload) {
        commit('ADD_ALERT', payload);
    },

    refreshList: function ({commit}) {
        commit('INCREASE_LIST_REFRESH_KEY');
    },

    sidebarSize: function ({commit}, payload) {
        commit('SET_SIDEBAR_SIZE', payload);
    },
};
